import { render, staticRenderFns } from "./AFormHelp.vue?vue&type=template&id=5b91955c&scoped=true&"
import script from "./AFormHelp.vue?vue&type=script&lang=js&"
export * from "./AFormHelp.vue?vue&type=script&lang=js&"
import style0 from "./AFormHelp.vue?vue&type=style&index=0&id=5b91955c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91955c",
  null
  
)

export default component.exports